import { render, staticRenderFns } from "./TagManagerModal.vue?vue&type=template&id=e90d1b9a&scoped=true&"
import script from "./TagManagerModal.vue?vue&type=script&lang=js&"
export * from "./TagManagerModal.vue?vue&type=script&lang=js&"
import style0 from "./TagManagerModal.vue?vue&type=style&index=0&id=e90d1b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90d1b9a",
  null
  
)

export default component.exports